import { css } from 'styled-components';
import { ContrastRegion, HighlightRegion } from '../../regions';
import baseStylesByKind from './baseStylesByKind';
import ContrastStyle from './ContrastStyle';
import HighlightStyle from './HighlightStyle';
const styleByRegion = {
  [ContrastRegion.displayName]: ContrastStyle,
  [HighlightRegion.displayName]: HighlightStyle
};
const KindStyle = css(["", " ", ""], _ref => {
  let {
    $kind
  } = _ref;
  return baseStylesByKind[$kind];
}, _ref2 => {
  let {
    $region
  } = _ref2;
  return styleByRegion[$region];
});
export default KindStyle;